import React from 'react';
import styled from 'styled-components';
import type { ComparisonHeader as ComparisonHeaderType } from '@sy/ssr-types';
import { Translation } from '~/components/Translation';
import ResponsiveText from '~/components/ResponsiveText';

const Section = styled.div`
	display: flex;
	padding: 40px 0px;
	flex-direction: column;
	align-items: center;
	align-self: stretch;

	@media (max-width: 500px) {
		padding: 20px 0px;
	}
`;

const TextContainer = styled.div`
	display: flex;
	max-width: 620px;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 24px;
`;

const Title = styled(ResponsiveText)`
	text-align: center;
`;

const Subtitle = styled(ResponsiveText)`
	justify-self: center;
	text-align: center;
	margin: 0 100px;
	max-width: 800px;

	@media (max-width: 500px) {
		margin: 0 50px;
	}
`;

type ComparisonHeaderProps = ComparisonHeaderType;

const ComparisonHeader: React.FC<ComparisonHeaderProps> = ({
	titleKey,
	subtitleKey,
}) => {
	return (
		<Section>
			<TextContainer>
				<Title variant="h2" textAlign="center">
					<Translation tid={titleKey} />
				</Title>
				<Subtitle variant="body" textAlign="center">
					<Translation tid={subtitleKey} />
				</Subtitle>
			</TextContainer>
		</Section>
	);
};

export default ComparisonHeader;
